import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { SignUpPageContent } from 'client/contents/SignUpContent/SignUpContent'

type TProps = {}

const SignUpPage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <SignUpPageContent />
    </article>
  )
}

export default SignUpPage
